import Header from 'catalogs/components/list/CatalogsListHeader';
import Filters from 'catalogs/components/list/CatalogsListFilters';
import Table from 'catalogs/components/list/CatalogsListTable';
import Row from 'catalogs/components/list/CatalogsListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/index.js